<template>
  <b-container class="company-panel">
    <accordion-panel
      id="alarm-level-panel"
      :collapsed.sync="collapsedProxy"
    >
      <template #title>
        <label class="company-panel__company-name">
          {{ value.companyName }}
        </label>
      </template>
      <company-alarms-summary :company="value" class="mb-2"/>
      <div v-for="(regional, index) in value.regional" :key="index">
        <regional-alarm-infos
          :regional="regional"
          :filter="filter"
          @recognize-alarm="onRecognizeAlarm"
        />
      </div>
    </accordion-panel>
  </b-container>
</template>

<script>
import AccordionPanel from '@/components/AccordionPanel';
import CompanyAlarmsSummary from './CompanyAlarmsSummary';
import RegionalAlarmInfos from './RegionalAlarmInfos';

export default {
  components: {
    AccordionPanel,
    CompanyAlarmsSummary,
    RegionalAlarmInfos,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    individualCollapse() {
      return this.value.collapse;
    },
    collapsedProxy: {
      get() {
        if (this.individualCollapse === undefined) return true;
        return !!this.individualCollapse;
      },
      set(value) {
        this.$emit('collapsed-change', { id: this.value.companyId, value });
      },
    },
  },
  methods: {
    onRecognizeAlarm() {
      this.$emit('recognize-alarm');
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .company-panel
    margin-top: 15px
    &__company-name
      color: $color-secondary
      font-size: 1.1rem
      margin-bottom: 0
    ::v-deep .accordion-panel
      border: var(--color-border-inner) 1px solid
      border-radius: 5px
      box-shadow: none
    ::v-deep .accordion-panel__header
      background-color: transparent
</style>
